import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BllinkUtils from '../../../common/utils/utils';
import Money from '../../../common/utils/money';
import { constants } from '../../../common/constants/constants';
import ArrowRight from '../../../images/arrow-right.png';
import MonthlyReportsTable from '../monthly_reports_table/MonthlyReportsTable';
import useBodyClass from '../../../common/hooks/useBodyClassName';
import { MonthlyReportsAtPartnerWrapper } from './monthlyReportsAtPartner.styled';
import {CurrencyValue} from "../../../common/currencyValue";
import {isAdminSelector} from "../../../store/auth/selectors";

const MonthlyReportsAtPartner = ({ match }) => {
    const { t } = useTranslation();
    const { partnerID, month, year } = match.params;
    const monthlyReportsSearchResults = useSelector(state => state.reports.monthlyReportsSearchResults);
    const ltr = useSelector((state) => state.common.ltrEnabled);

    useBodyClass('report');

    const [currentMonth, setCurrentMonth] = useState({
        label: `${t(`common.months.${month}`)} ${year}`,
        value: `${month}_${year}`
    });
    const isAdmin = useSelector(isAdminSelector);
    const [title, setTitle] = useState('');
    const [titleTooltip, setTitleTooltip] = useState('');
    const [subtitle, setSubtitle] = useState('');
    const [showCheque, setShowCheque] = useState(false);
    const [total, setTotal] = useState();
    const [currency, setCurrency] = useState();
    const [totalInCredit, setTotalInCredit] = useState();
    const [totalFuture, setTotalFuture] = useState();
    const [totalToWithdraw, setTotalToWithdraw] = useState();

    useEffect(() => {
        if (monthlyReportsSearchResults) {
            const { Total, TotalInCreditCard, TotalInCheque, TotalFuture, TotalToWithdraw, currencyTotal } = monthlyReportsSearchResults;
            if (Total) setTotal(Total);
            if (TotalInCreditCard || TotalInCreditCard === 0) setTotalInCredit(TotalInCreditCard);
            if (TotalInCheque) setShowCheque(true);
            if (TotalFuture || TotalFuture === 0) setTotalFuture(TotalFuture)
            if (TotalToWithdraw || TotalToWithdraw === 0) setTotalToWithdraw(TotalToWithdraw)
            if (currencyTotal) setCurrency(currencyTotal);
        }
    }, [monthlyReportsSearchResults]);

    useEffect(() => {
        let monthTotal = Money.roundNumber(total);
        monthTotal = BllinkUtils.Strings.numberWithCommas(monthTotal);
        const currencyTotal = currency ? t(`currency.${currency}`): '';
        const parts = currentMonth.value.split('_');
        const thisMonth = parts[0];
        const thisYear = parts[1];
        const tableTitle = t('reports.monthly_cashflow_table_title', {monthName: t(`common.months.${thisMonth}`), year: thisYear, amount: monthTotal, currency: currencyTotal});
        setTitle(tableTitle);
        setTitleTooltip(t('reports.monthly_partner_cashflow_table_title_tooltip'));

        setSubtitle(
            <>
                {(totalInCredit || totalInCredit === 0) && (
                    <div>
                        {t('reports.monthly_cashflow_sub_title')}
                        <CurrencyValue currency={currency}>{BllinkUtils.Money.roundNumber(totalInCredit) * 100}</CurrencyValue>
                    </div>
                )}
                {(totalFuture || totalFuture === 0) && (
                    <div className='mt-1'>
                        {t('reports.monthly_cashflow_sub_title_future')}
                        <CurrencyValue currency={currency}>{BllinkUtils.Money.roundNumber(totalFuture) * 100}</CurrencyValue>
                    </div>
                )}
                {(isAdmin && (totalToWithdraw || totalToWithdraw === 0)) && (
                    <div className='mt-1'>
                        {t('reports.monthly_cashflow_sub_title_early_withdrawal')}
                        <CurrencyValue currency={currency}>{BllinkUtils.Money.roundNumber(totalToWithdraw) * 100}</CurrencyValue>
                    </div>
                )}
            </>
        )
    }, [currentMonth, total, totalInCredit, currency]);

    const onMonthChange = e => {
        let parts = e.value.split('_');
        let newMonth = parts[0];
        let newYear = parts[1];
        window.location.href = `/${constants.pages.partnerMonthlyReports}/${partnerID}/${newMonth}/${newYear}`
    };

    const onChequeDepositClick = () => {
        return `/${constants.pages.monthlyPartnerChequesUrl}/${partnerID}/${currentMonth.value.split('_')[0]}/${currentMonth.value.split('_')[1]}`
    };

    return (
        <MonthlyReportsAtPartnerWrapper ltr={ltr}>
            <div className="back-link mt-2" data-testid='back-link'>
                <Link to={`/${constants.pages.buildingManagerCompanyProfileUrl}/${partnerID}`}>
                    <img alt='return_to_details' src={ArrowRight} />
                    <span>{t('reports.back_to_dashboard')}</span>
                </Link>
            </div>
            <MonthlyReportsTable
                partnerID={partnerID}
                tableTitle={title}
                tableSubtitle={subtitle}
                titleToolTip={titleTooltip}
                year={currentMonth.value.split('_')[1]}
                currentMonth={currentMonth.value.split('_')[0]}
                onMonthChange={onMonthChange}
                exportTitle={t('reports.export_title')}
                showChequeDeposit={showCheque}
                onChequeDepositClick={onChequeDepositClick}
                multipleBuildings
            />
        </MonthlyReportsAtPartnerWrapper>
    )
};

export default MonthlyReportsAtPartner;
